import { Injectable } from '@angular/core';
import envConfig from "./../../config/environment-variable-config.json";

@Injectable({
	providedIn: 'root'
})
export class AppInitService {
	/**
	 * Loads the configuration data and sets it to a global variable.
	 */
	public async loadConfiguration() {
		const configData: any = envConfig;
		window.environmentVariableConfig = configData;
	}
}
